import { render } from "./FormStatsCard.vue?vue&type=template&id=3e64b857&scoped=true&ts=true"
import script from "./FormStatsCard.vue?vue&type=script&lang=ts"
export * from "./FormStatsCard.vue?vue&type=script&lang=ts"

import "./FormStatsCard.vue?vue&type=style&index=0&id=3e64b857&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e64b857"]])

export default __exports__